// prettier-ignore
const CATEGORY_MAP = [
    { category: 0, min: 0, max: 10, label: "Uitstekend", color: "rgb(18,39,251)" },
    { category: 10, min: 10, max: 15, label: "Zeer goed", color: "rgb(92,151,252)" },
    { category: 15, min: 15, max: 20, label: "Zeer goed", color: "rgb(2,118,60)" },
    { category: 20, min: 20, max: 25, label: "Vrij goed", color: "rgb(108,190,69)" },
    { category: 25, min: 25, max: 30, label: "Gewoon", color: "rgb(245,236,72)" },
    { category: 30, min: 30, max: 35, label: "Matig", color: "rgb(250,198,64)" },
    { category: 35, min: 35, max: 40, label: "Ondermaats", color: "rgb(241,88,34)" },
    { category: 40, min: 40, max: 45, label: "Slecht", color: "rgb(237,31,36)" },
    { category: 45, min: 45, max: 50, label: "Zeer slecht", color: "rgb(156,35,117)" },
    { category: 50, min: 50, max: 99, label: "Uiterst slecht", color: "rgb(46,41,64)" },
  ];

export default CATEGORY_MAP;
